import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AssistantState } from './assistant.state';

export const ASSISTANT_FEATURE_KEY = 'assistant';

export const selectAssistant = createFeatureSelector<AssistantState>(ASSISTANT_FEATURE_KEY);

export class AssistantSelectors {
  private static readonly _slice = selectAssistant;

  public static readonly isOpen = createSelector(
    this._slice,
    (state) => state.isOpen,
  );

  public static readonly size = createSelector(
    this._slice,
    (state) => state.size,
  );
}
